<div class="w-full pb-base flex items-center" [ngClass]="{ '!pb-sm': addNewShop }">
  <div class="number-container" [ngClass]="{ '!bg-primary': activeSection >= 1 }">1</div>
  <div class="divider"></div>
  <div class="number-container" [ngClass]="{ '!bg-primary': activeSection >= 2 }">2</div>
  <div class="divider"></div>
  <div class="number-container" [ngClass]="{ '!bg-primary': activeSection >= 3 }">3</div>
  <div class="divider"></div>
  <div class="number-container" [ngClass]="{ '!bg-primary': activeSection === 4 }">4</div>
</div>
